import { Props_SnippetImageContent } from './ImageContent.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, repeatable_link } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content-column__heading--${heading.visibility.value}` : ''
    const classSnippetType = `snippet-image-content--type-${snippet.type?.value}`
    const classSnippetLayout = `snippet-image-content--layout-${snippet.layout?.value}`
    const classSnippetTheme = `snippet-image-content--theme-${snippet.theme?.value}`

    return (
    <section className={`snippet-image-content ${classSnippetType} ${classSnippetLayout} ${classSnippetTheme}`}>
        <div className="snippet-image-content__container">
            <div className="snippet-image-content__container-image">
                <img
                    loading="lazy"
                    src={image.src?.value}
                    className="snippet-image-content__image"
                    height="370"
                    width="410"
                    alt={image.alt?.value ? image.alt.value : ''}
                />
            </div>
            <div className="snippet-image-content__container-content">
                <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                <div className="snippet-image-content__content">
                    { Legacy_CompileMarkdown(content.content?.value || '') }
                </div>
                {
                    repeatable_link.length > 0 && (
                        <div className="snippet-image-content__container-links">
                            { repeatable_link.map((link, index: number) => (
                                link.url?.value && link.content?.value && (
                                    <a
                                        key={index}
                                        className="snippet-image-content__link"
                                        href={link.url?.value}
                                        target={link.openInNewTab?.value === 'true' ? '_blank' : '_self'}
                                        rel={link.openInNewTab?.value === 'true' ? 'noopener noreferrer' : undefined}
                                    >
                                        {link.content?.value}
                                    </a>
                                )
                            ))}
                        </div>
                    )
                }
            </div>
        </div>
    </section>
    )
}

export default SnippetImageContent